import React, { useEffect } from "react"
import { Route, Redirect } from "react-router-dom"
import { connect } from "react-redux"
import { FirebaseContext } from "../../firebase"
import ChatHeader from "../ChatHeader/ChatHeader"
import { dispatchLogout } from "../../redux/actionCreators/auth"

const PrivateRoute = ({
  component: Component,
  auth: { isAuthenticated, loading },
  chatHeaderEnabled,
  dispatchLogout,
  ...rest
}) => (
  useEffect(() => {
    function storageHandler(event) {
      if (event.key === "token" && event.oldValue && !event.newValue) {
        dispatchLogout()
      }
    }
    window.addEventListener("storage", storageHandler)
    return () => window.removeEventListener("storage", storageHandler)
  }, []),
  (
    <FirebaseContext.Consumer>
      {(context) => (
        <Route
          {...rest}
          render={(props) =>
            isAuthenticated ? (
              <React.Fragment>
                {chatHeaderEnabled ? <ChatHeader /> : null}
                <Component date={context.dateState} {...props} />
              </React.Fragment>
            ) : (
              <Redirect to="/register" />
            )
          }
        />
      )}
    </FirebaseContext.Consumer>
  )
)

const mapStateToProps = (state) => ({
  auth: state.auth,
})

export default connect(mapStateToProps, { dispatchLogout })(PrivateRoute)
